import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminService } from '@app/services/admin/admin.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-admin-create-account',
  templateUrl: './admin-create-account.component.html'
})
export class AdminCreateAccountComponent implements OnInit {
  accountForm;
 

  constructor(
    private adminService: AdminService,
    private fb: FormBuilder,
    private messageService: MessageService) { }

    ngOnInit(): void {
      this.accountForm = this.fb.group({
        memberId: ['', Validators.required]
      }
      );
    }

  createAccount() {
    let missingmembers = [];
    missingmembers.push(this.accountForm.get('memberId').value);

    this.adminService.ProcessNonCreatedUsers(missingmembers).subscribe(resp => {
      if (resp === true) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Konto skapat för: ' + this.accountForm.get('memberId').value });
        this.accountForm.reset();
      }
    });
  }
}
